import { useAuth } from '@clerk/clerk-react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAtom } from 'jotai/index';
import { useEffect } from 'react';
import { authAtom } from '~/atoms/authAtom';

export const Route = createFileRoute('/_authLayout/on-logged')({
  component: onLogged,
});

export function onLogged() {
  const [_, setAuthStore] = useAtom(authAtom);
  const navigate = useNavigate();

  const auth = useAuth();

  useEffect(() => {
    if (auth.isSignedIn) {
      setAuthStore({ auth: auth });
      navigate({ to: '/' });
    } else if (auth.isLoaded) {
      setAuthStore(null);
    }
  }, [auth, setAuthStore, navigate]);

  return null;
}
